export default "__VITE_ASSET__HsyDTrfu__"